import _get from 'lodash/get';

export const DEFAULT_VIDEO_BLOCK_CLASS_NAME = 'video-block';
export const ARG_NAME_COMPONENT_NAME = 'componentName';
export const ARG_NAME_COMPONENT_IDENTIFIER = 'componentIdentifier';
export const ARG_NAME_DATA_PATH = 'dataPath';
export const VIDEO_PLAYER_COMPONENT_CONFIGURATION_ID_NAME = 'componentConfigurationId';

export const VIDEO_PLAYER_URL_PROP_NAME = 'url';
export const VIDEO_PLAYER_URL_DATA_PATH = 'data.video.url';
export const VIDEO_PLAYER_VIDEO_ID_PROP_NAME = 'videoId';
export const VIDEO_PLAYER_VIDEO_ID_DATA_PATH = 'data.video.videoId';
export const VIDEO_PLAYER_SOURCE_PROP_NAME = 'source';
export const VIDEO_PLAYER_SOURCE_DATA_PATH = 'data.video.source';
export const VIDEO_PLAYER_PLACEHOLDER_PROP_NAME = 'placeholder';
export const VIDEO_PLAYER_PLACEHOLDER_DATA_PATH = 'data.video.placeholder';

export const VIDEO_PLAYER_PROP_TO_DATA_PATH_MAP = {
  [VIDEO_PLAYER_URL_PROP_NAME]: VIDEO_PLAYER_URL_DATA_PATH,
  [VIDEO_PLAYER_VIDEO_ID_PROP_NAME]: VIDEO_PLAYER_VIDEO_ID_DATA_PATH,
  [VIDEO_PLAYER_SOURCE_PROP_NAME]: VIDEO_PLAYER_SOURCE_DATA_PATH,
  [VIDEO_PLAYER_PLACEHOLDER_PROP_NAME]: VIDEO_PLAYER_PLACEHOLDER_DATA_PATH,
};

export function getVideoPlayerDataPath(propName) {
  return _get(VIDEO_PLAYER_PROP_TO_DATA_PATH_MAP, propName, `data.video.${propName}`);
}

export const VIDEO_BLOCK_PAGE_CONTENT_QUERY = {
  data: {
    video: {
      url: true,
      videoId: true,
      source: true,
      placeholder: true,
    },
  },
};
